import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-universal-search-modal',
  templateUrl: './universal-search-modal.component.html',
  styleUrls: ['./universal-search-modal.component.css']
})
export class UniversalSearchModalComponent {
  public databaseTables: any = [{ name: 'table 1' }, { name: 'table 2' }];
  public auditTypes: any = [{ name: '(I)nsert' }, { name: '(U)pdate' }, { name: '(D)elete' }];
  public isShowModal: boolean = true;

  public selectedAuditTypes: any[] = [];
  public selectedCreatedByColumn: any = null;
  public selectedUpdatedByColumn: any = null;
  public userValueToSearchFor: string = '';

  @Input() columns: any = [];
  @Output() dialogCloseEmitter = new EventEmitter<boolean>();
  @Output() beginUniversalSearch = new EventEmitter<any>();

  constructor() {

  }

  dialogClose() {
    this.dialogClosedEmitter();
  }

  dialogClosedEmitter() {
    this.dialogCloseEmitter.emit(false);
  }

  startSearch() {
    this.dialogCloseEmitter.emit(false);
    const a: any = {
      CreatedByUser: this.userValueToSearchFor,
      AuditTypes: this.getAuditTypeCodes().join(', '),
      CreatedByUserColumnName: this.selectedCreatedByColumn.Name,
      UpdatedByUserColumnName: this.selectedUpdatedByColumn.Name
    };

    console.log(a);
    this.beginUniversalSearch.emit(a);
  }

  private getAuditTypeCodes(): string[] {
    return this.selectedAuditTypes.map(auditType => {
      // Assuming the format is always "(X)rest", where `X` is the character we need
      return auditType.name.substring(1, 2); // This gets the character between the parentheses
    });
  }

  public resetSearch() {
    this.userValueToSearchFor = '';
    this.selectedCreatedByColumn = null;
    this.selectedUpdatedByColumn = null;
    this.userValueToSearchFor = '';
    this.selectedAuditTypes = [];
  }

}
